import { instance } from "../instance";
import { PATH } from "../../shared/constants";
import { operatorPortalIdTokenHeaders } from "./operatorAdminChat";

export interface OperatorNotificationChecklistRow {
  gameId: string;
  gameLabel: string;
  submittedByEmail: string;
  submittedByDisplayName?: string;
  submittedAt: string;
}

export interface OperatorNotificationAccessRow {
  email: string;
  firstName?: string;
  name?: string;
  role: string;
  created: string;
}

export interface OperatorNotificationSupportRow {
  _id: string;
  fanEmail: string;
  assigned: string;
  assignedDisplayName?: string;
  status: string;
  createdAt: string;
  messagePreview?: string;
  pageHost?: string;
}

/** Ongoing games the operator is assigned to (operators only; empty for super-admins). */
export interface OperatorNotificationAssignedGameRow {
  gameId: string;
  gameLabel: string;
  startDate: number;
  startTime?: string;
}

/**
 * Unread admin↔super-admin chat threads for this viewer (operators: super-admin replies;
 * super admins: thread activity not authored by them).
 */
export interface OperatorNotificationAdminChatRow {
  threadKey: string;
  operatorEmail: string;
  operatorDisplayName?: string;
  gameId: string | null;
  gameLabel: string;
  lastMessageAt: string;
  /** Latest message Mongo id; aligns with realtime socket payload for sound dedupe. */
  lastMessageId?: string;
  preview: string;
}

export interface OperatorNotificationClientTrackerStaleRow {
  teamId: string;
  teamName: string;
  lastClientContactAt: string | null;
  sentAt: string;
}

export interface OperatorNotificationMappingNoteRow {
  noteId: string;
  cameraId: string;
  cameraName: string;
  lastReplyAt: string;
  preview: string;
  replyAuthorName?: string;
}

export interface OperatorNotificationSnapshot {
  checklistFinishes: OperatorNotificationChecklistRow[];
  newAccessRecords: OperatorNotificationAccessRow[];
  supportAssigned: OperatorNotificationSupportRow[];
  assignedGames: OperatorNotificationAssignedGameRow[];
  adminChatAlerts?: OperatorNotificationAdminChatRow[];
  clientTrackerStaleContacts?: OperatorNotificationClientTrackerStaleRow[];
  mappingNoteAlerts?: OperatorNotificationMappingNoteRow[];
}

export async function getOperatorNotificationSnapshot(
  viewerEmail: string,
): Promise<OperatorNotificationSnapshot> {
  const { data } = await instance.get<OperatorNotificationSnapshot>(
    `${PATH.API}/${PATH.OPERATOR}/access/notification-snapshot`,
    { params: { email: viewerEmail }, ...operatorPortalIdTokenHeaders() },
  );
  return data;
}
